/** Shopify CDN: Minification failed

Line 56:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 57:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 47:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 89:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 38:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 39:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 80:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 20:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 21:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 11:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 12:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 35:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends DetailsDisclosure {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        closeButton: this.querySelector('.share-button__close'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => { navigator.share({ url: this.urlToShare, title: document.title }) });
      } else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.closeButton.classList.add('hidden');
        this.elements.shareSummary.focus();
      }
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        this.elements.successMessage.classList.remove('hidden');
        this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
        this.elements.closeButton.classList.remove('hidden');
        this.elements.closeButton.focus();
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }
  });
}
